export default __webpack_public_path__ + "a5212faaf00f098057fa3d3f2c9e66cc.png";